import http from "../../services/http";
import { __api_getRecentEvent } from "./admin.endpoints";
import { __api_getSPRecentEvent } from "../service-provider/sp.endpoints"
export const getRecentEvent = (isAdmin) => http.Request("GET", isAdmin ? __api_getRecentEvent : __api_getSPRecentEvent);
